export default {
  open: 'Open',
  onHold: 'On Hold',
  approved: 'Approved',
  needsApproval: 'Needs Approval',
  drafting: 'Drafting',
  filled: 'Filled',
  cancelled: 'Cancelled',
  closed: 'Closed',
};



// WEBPACK FOOTER //
// ./src/constants/jobStatuses.js